import { Button, Card, Col, Form as FormAnt, InputNumber, Modal, Row, Spin, message } from 'antd';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { companies } from '../../../../../../../API/TT_ELD/Users/company';
import { useCompanyData } from '../../../../../../../Hooks/TT_ELD/Companies';
import Notfound from '../../../../../../../Utils/Notfound';
import { getUserFromLocalStorage } from '../../../../../../../Utils/sidebar';

type params = { readonly id: any };
type MyObjectType = { [key: string | number]: any };

const SubcriptionQuantity = () => {
  const { id } = useParams<params>();
  const { data, status, refetch }: MyObjectType = useCompanyData(id);

  const user = getUserFromLocalStorage();
  const [form] = FormAnt.useForm();

  const [loadings, setLoadings] = useState<boolean[]>([]);

  const setLoading = (index: number, val: boolean) => {
    setLoadings((prev) => {
      const next = [...prev];
      next[index] = val;
      return next;
    });
  };

  const onSubmit = async (values: any) => {
    const payload = { ...values, companyId: id };

    try {
      setLoading(1, true);
      await companies.updateSubscriptionData(payload);
      await refetch();
      message.success('Updated');
    } catch (e) {
      message.error('Update failed');
      throw e;
    } finally {
      setLoading(1, false);
    }
  };

  const handleIncreaseWithConfirm = () => {
    const currentQty = Number(form.getFieldValue('quantity') ?? 0);

    Modal.confirm({
      title: 'Increase quantity?',
      content: `Quantity will be increased by 1 (${currentQty} → ${currentQty + 1}).`,
      okText: 'Increase',
      cancelText: 'Cancel',
      onOk: async () => {
        form.setFieldsValue({ quantity: currentQty + 1 });
        await form.validateFields(['quantity']);
        form.submit(); // onFinish => onSubmit
      },
    });
  };

  return (
    <div className="mainPage">
      <Card>
        {status === 'loading' ? (
          <Spin size="large" spinning={!data} />
        ) : data ? (
          <FormAnt
            form={form}
            name="basic"
            layout="vertical"
            initialValues={{ ...data, quantity: data?.quantity }}
            onFinish={onSubmit}
            autoComplete="off"
          >
            <Row gutter={[12, 10]}>
              <Col xs={24} sm={24} md={12} lg={6}>
                <FormAnt.Item
                  label="Quantity"
                  name="quantity"
                  rules={[
                    { required: true, message: 'Quantity is required' },
                    { type: 'number', min: 0, message: 'Quantity must be >= 0' },
                  ]}
                  style={{ marginBottom: 0 }}
                >
                  <InputNumber
                    placeholder="quantity"
                    style={{ width: '100%' }}
                    disabled={user.role === 'support_manager'}
                  />
                </FormAnt.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={4} style={{ marginTop: 30 }}>
                {user.role === 'support' && (
                  <Button type="primary" onClick={handleIncreaseWithConfirm}>
                    Increase
                  </Button>
                )}
              </Col>
            </Row>

            <FormAnt.Item style={{ marginTop: 16 }}>
              <Button
                disabled={user.role === 'support_manager'}
                loading={loadings[1]}
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </FormAnt.Item>
          </FormAnt>
        ) : (
          <Notfound />
        )}
      </Card>
    </div>
  );
};

export default SubcriptionQuantity;
